// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"96":"e6b71b31ed58d656","273":"893c488b6176b8af","409":"8207d0912f2f5138","514":"42706af825b8dedf","965":"90461f17b51c171b"}[chunkId] + ".js";
};